import React from "react";
import { BlockView } from "common/views/block/BlockView.view";
import Query from "core/api/QueryComponent";
import TokenSession from "core/util/session/TokenSession";
import FFHTMLWidget from "./FFHTMLWidget";
import { ButtonView } from "common/views/button/Button.view";
import HtmlDefault from "common/fragments/HtmlDefault";
import Icon from "common/views/icon/Icon";
import { IconNames } from "@blueprintjs/icons";
export interface InstitutionHTMLComponentProp {
    queryArgs: any;
    toggleOpen: () => void;
    showDialog: (data:any) => void;
} 
const InstitutionHTMLComponent = ({queryArgs, toggleOpen, showDialog, }:InstitutionHTMLComponentProp) => {
        return (
			<div>
				<Query.One
					entity={FFHTMLWidget}
					args={queryArgs}
				>
					{req => {
						return (
							<BlockView viewKey="card-primary">
								{TokenSession.hasRoles("ROLE_ADMIN") && (
									<div>
										{showDialog(req.data)}
										<ButtonView viewKey="instituion.edit.html" onClick={toggleOpen}>
											<Icon icon={IconNames.EDIT} />
										</ButtonView>
									</div>
								)}
								<HtmlDefault
									html={
										req.data
											? req.data.fftext
											: "<b>[]</b>"
									}
								/>
							</BlockView>
						);
					}}
				</Query.One>
			</div>
		);
        
}
export default InstitutionHTMLComponent;


// WEBPACK FOOTER //
// ./src/panels/institutions/InstitutionHTMLComponent.tsx